import script from "./Results.vue?vue&type=script&setup=true&lang=js"
export * from "./Results.vue?vue&type=script&setup=true&lang=js"

import "./Results.vue?vue&type=style&index=0&id=1acc9b8f&lang=scss&scoped=true"

import exportComponent from "/home/deployer/deploypad/silogues/releases/20261022152544/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1acc9b8f"]])

export default __exports__